import { WacPreviewState } from 'owa-sxsdata';
import { isStringNullOrWhiteSpace } from 'owa-localize';

export function canLoadWacUsingJsApi(previewState: WacPreviewState) {
    return (
        previewState?.jsApiInfo && !isStringNullOrWhiteSpace(previewState.jsApiInfo.bootScriptUrl)
    );
}
